import styled from "styled-components";
import AdminService from "../../../services/admin.service";
import { useState, useEffect, SetStateAction, Dispatch } from "react";
import { Seller } from "../../../types/common.types";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { add, format } from "date-fns";
import CalendarDual from "../../common/CalendarDual";
import { useGlobal } from "../../../context/global";
import { mobile } from "../../../styles/responsive";

interface SellersFilterInterface {
    day: Date,
    endDay: Date | undefined,
    setDay: Dispatch<SetStateAction<Date>>,
    setEndDay: Dispatch<SetStateAction<Date | undefined>>,
    setSellerId: Dispatch<SetStateAction<string | undefined>>
}

export default function SellersFilter({day, setDay, setSellerId, endDay, setEndDay}: SellersFilterInterface) {
    const { setIsLoading } = useGlobal()
    const [list, setList] = useState<Seller[]>([])
    const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false)
    
    useEffect(() => {
        async function getSellers() {
            setIsLoading(true)
            try {
                const response = await (await AdminService.listSellers()).data
                setList(response)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        getSellers()
    }, [])

    function addDay(days: number) {
        const newDay = add(day, {days})
        setDay(newDay)
    }

    return (
        <Main>
            <button
                onClick={() => addDay(-1)}
            >
                <IoIosArrowBack/>
            </button>
            <div className="filters">
                <div className="date">
                    <button 
                        className="open-calendar"
                        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                    />
                    <span>
                        {day ? `${format(day, 'dd/MM/yyyy')} ${endDay ? '- ' + format(endDay, 'dd/MM/yyyy') : ''}` : '-'}
                    </span>
                    <div className={`calendar ${isCalendarOpen ? 'open' : ''}`}>
                        <CalendarDual
                            endDay={endDay}
                            setEndDay={setEndDay}
                            selectedDay={day}
                            setSelectedDay={setDay}
                            selectPastDays
                        />
                    </div>
                </div>
                <div className="dropdown">
                    <select
                        onChange={e => setSellerId(e.target.value)}
                    >
                        <option disabled selected>-</option>
                        <option value="all">Todos</option>
                        {
                            list.map((seller, idx) => {
                                return <option key={idx} value={seller.id}>{seller.name}</option>
                            })
                        }
                    </select>
                </div>
            </div>
            <button
                onClick={() => addDay(1)}
            >
                <IoIosArrowForward/>
            </button>
        </Main>
    )
}

const Main = styled.div`
    width: 100%;
    padding: 30px 0;
    display: flex;
    justify-content: space-around;
    
    .filters {
        flex: 1;
        display: flex;
        justify-content: center;
        gap: 10px;
        z-index: 20;
        ${mobile({
            flexDirection: 'column',
            alignItems: 'center'
        })}
    }
    
    .filters > .dropdown {
        height: 100%;
        
        select {
            height: 100%;
            padding: 5px 10px;
        }
    }
    
    .filters > .date {
        padding: 20px;
        width: 70%;
        max-width: 350px;
        text-align: center;
        height: 100%;
        position: relative;
        z-index: 10;
        
        > button.open-calendar {
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            background-color: ${props => props.theme.blueLight};
            cursor: pointer;
            border: none;
        }
        
        > .calendar {
            display: none;
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            
            &.open {
                display: initial;
            }
        }
        
        > span {
            color: #FFF;
            position: absolute;
            white-space: nowrap;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 10;
        }
    }
    
    > button {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 30px;
        border: none;
        background-color: ${props => props.theme.white};
        font-size: 16px;
        color: #000;
        box-shadow: 0 5px 3px ${props => props.theme.blackTransparent};
        transition: transform .3s ease;
        cursor: pointer;
        
        &:hover {
            transform: translateY(-3px);
        }
    }
`;